export const DEFAULT_CPT_TIME_LIMIT = 30;

export const ONE_HOUR_DELIVERY = "1h Delivery";
export const NIGHTOWL = "Nightowl";
export const SUNRISE = "Sunrise";
export const COFFEE = "Coffee";
export const BREAKFAST = "Breakfast";
export const BRUNCH = "Brunch";
export const LUNCH = "Lunch";
export const DINNER = "Dinner";
export const SUPPER = "Supper";
export const BEDTIME = "Bedtime";
export const TWILIGHT = "Twilight";
export const MISSING_INFORMATION = "Missing Information";

export const IN_PROGRESS = "In Progress";
export const INTERIM_STAGED = "Staged-Interim";
export const STAGED = "Staged";
export const STOWED = "Stowed";
export const ASSIGNED = "Assigned";
export const DEPARTED = "Departed";

export const HOURS = 3600;
export const BRUNCH_START = HOURS * 8; //28800
export const BRUNCH_END = HOURS * 11; //39600
export const LUNCH_END = HOURS * 15; //54000
export const DINNER_END = HOURS * 18; //64800
export const BEDTIME_END = HOURS * 22; //79200



// WEBPACK FOOTER //
// ./src/components/outboundSSD/util/Constants.js